import { render, staticRenderFns } from "./VideoRecorder.vue?vue&type=template&id=735115b5&scoped=true"
import script from "./VideoRecorder.vue?vue&type=script&lang=js"
export * from "./VideoRecorder.vue?vue&type=script&lang=js"
import style0 from "./VideoRecorder.vue?vue&type=style&index=0&id=735115b5&prod&scoped=true&lang=css"
import style1 from "./VideoRecorder.vue?vue&type=style&index=1&id=735115b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735115b5",
  null
  
)

export default component.exports